import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";
export async function AddAdvisorFirmMultiUser(advisor_firm_user) {

    const Token = sessionStorage.getItem("Token");
    const header = { Authorization: `Bearer ${Token}` };

    var raw = JSON.stringify({
        session_id: Token,
        advisor_firm_user: advisor_firm_user
    });

    var requestOptions = {
        method: "POST",
        body: raw,
        redirect: "follow",
        headers: header,
    };

    if (!CheckSessionTimeout(Token)){
        try {
            const response = await fetchWithTimeout(
                process.env.REACT_APP_ADVISOR_FIRM_MULTIUSER_API,
                requestOptions
            );
            const message = await response.json();
            if (!response.ok) {
                return { status: response.status, error: message.error || message };
            } else {
                return { status: response.status, result: message.result };
            }
        } catch (error) {
            return { status: 0, error: error.message };
        }
    } else {
        return { status: 401 };
    }
}
